import { render, staticRenderFns } from "./ActiveContent.vue?vue&type=template&id=79051c1a&scoped=true"
import script from "./ActiveContent.vue?vue&type=script&lang=js"
export * from "./ActiveContent.vue?vue&type=script&lang=js"
import style0 from "./ActiveContent.vue?vue&type=style&index=0&id=79051c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79051c1a",
  null
  
)

export default component.exports